<template lang="pug">
  v-dialog(v-model="showLoading" persistent width="300")
    v-card(color="secondary white--text")
      v-card-text(class="white--text") {{ $t('loading.PLEASE_WAIT') }}
        v-progress-linear(indeterminate color="white" class="mb-0")
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: mapGetters(['showLoading'])
}
</script>

<!--<v-dialog v-model="showLoading" persistent width="300">
    <v-card color="secondary white--text">
      <v-card-text class="white--text">
        {{ $t('loading.PLEASE_WAIT') }}
        <v-progress-linear
          indeterminate
          color="white"
          class="mb-0"
        ></v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>
